import React from "react";
import PropTypes from "prop-types";
import { ListGroup } from "react-bootstrap";
import { ArrowRight } from "react-feather";

export default function SingleCard(props) {
  return (
    <ListGroup.Item
      action
      href={props.url}
      className="d-flex justify-content-between"
    >
      <span>{props.title}</span>
      <ArrowRight stroke="#4C76BA" />
    </ListGroup.Item>
  );
}

SingleCard.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
};

SingleCard.defaultProps = {
  title: "Overskrift",
  url: "/",
};
